import BaseButton from "../base";
import { FunctionComponent, ReactNode } from "react";

export type IconButtonType = {
  /** Variant props */
  size?: "lg" | "xl" | "md" | "sm";
  state?: "default" | "loading" | "disabled";
  style?: "primary" | "tertiary";
  width?: "hug content" | "fill container";

  /** Custom Props  */
  className?: string;
  color?:
    | "coral"
    | "black"
    | "white"
    | "blackWhite"
    | "whiteBlack"
  icon: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const IconButton: FunctionComponent<IconButtonType> = ({
  className = "",
  icon,
  size = "md",
  state = "default",
  style = "primary",
  width = "hug content",
  color = "coral",
  onClick,
}) => {
  return (
    <BaseButton
      className={className}
      icon={icon}
      size={size}
      state={state}
      style={style}
      width={width}
      onClick={onClick}
      color={color}
      type="icon"
    />
  );
};

IconButton.displayName = "IconButton";

export default IconButton;
